import { Flex } from "antd";

const FullCenterBox = ({ children }) => (
  <Flex align="center" justify="center">
    {children}
  </Flex>
);

export default FullCenterBox;
